import React from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import Accept from '../../assets/images/png-icons/accept.png';
import Lose from '../../assets/images/png-icons/lose.png';
import { DECISION_ACTION_TYPES } from '../../enums/betTypes';

const InsuranceButtons = observer(
  ({ handleDecisionAction, handleCloseInsurance, liveDecisionActionCounts }) => {
    return (
      <div className={`${isMobile() ? 'm-' : ''}decision-buttons-column`}>
        <div
          className={`${isMobile() ? 'm-' : ''}decision-buttons-c-row`}
          onClick={() => handleDecisionAction(DECISION_ACTION_TYPES.Insurance)}
        >
          <div className={`${isMobile() ? 'm-' : ''}decision-button hit`}>
            <span className={`${isMobile() ? 'm-' : ''}decision-percent`}>
              {liveDecisionActionCounts?.[DECISION_ACTION_TYPES.Insurance] || null}
            </span>
            <img src={Accept} alt='hit' className={`${isMobile() ? 'm-' : ''}decision-img`} />
            <p className={`${isMobile() ? 'm-' : ''}decision-button-name`}>Yes</p>
          </div>
        </div>
        <div
          className={`${isMobile() ? 'm-' : ''}decision-buttons-c-row`}
          onClick={handleCloseInsurance}
        >
          <div className={`${isMobile() ? 'm-' : ''}decision-button stand`}>
            <span className={`${isMobile() ? 'm-' : ''}decision-percent`} />
            <img src={Lose} alt='stand' className={`${isMobile() ? 'm-' : ''}decision-img`} />
            <p className={`${isMobile() ? 'm-' : ''}decision-button-name`}>No</p>
          </div>
        </div>
      </div>
    );
  }
);
export default InsuranceButtons;
